export default "__VITE_ASSET__DgOxyGxu__"